import {createSelector} from 'reselect';
import {StateShape} from '../redux/store/reducers';
import {hotelsSearchStateType} from '../redux/store/reducers/hotelsSearch';

export const getSearchState = (state: StateShape) => state.hotelsSearch;

export const getHotelsState = createSelector(
  getSearchState,
  (search: hotelsSearchStateType) => search.searchResults,
);

export const getAccessibilityDataState = createSelector(
  getSearchState,
  (search: hotelsSearchStateType) => search.accessibilityHotelsData,
);
